import { create } from 'zustand';

type ShouldShowNotificationBadgeType = {
  presentations: boolean;
  export: boolean;
  adjustments: boolean;
};

interface NotificationBadgeState {
  notificationBadges: ShouldShowNotificationBadgeType;
  setPresentationBadge: (show: boolean) => void;
  setExportBadge: (show: boolean) => void;
  setAdjustmentBadge: (show: boolean) => void;
}

/** Notify user that download is completed. currently used in AppProfile Icon */
const useNotificationsBadge = create<NotificationBadgeState>((set, get) => ({
  notificationBadges: {
    presentations: false,
    export: false,
    adjustments: false
  },
  setPresentationBadge: (show: boolean) => set(state => ({
    notificationBadges: { ...state.notificationBadges, presentations: show }
  })),
  setExportBadge: (show: boolean) => set(state => ({
    notificationBadges: { ...state.notificationBadges, export: show }
  })),
  setAdjustmentBadge: (show: boolean) => set(state => ({
    notificationBadges: { ...state.notificationBadges, adjustments: show }
  }))
}));

export default useNotificationsBadge;
